import type { FetchAllActivityTypes } from './typings'
import type { ActivityType } from '../../../typings'

export const fetchAllActivityTypesActionCreator = (
  payload: ActivityType[],
): FetchAllActivityTypes => ({ type: 'activityTypes/fetchAll', payload })
